import React from 'react';
import NavLinks from './NavLinks';

const Footer = () => {
  return (
    <footer className="relative z-10 mt-12 border-t border-gray-200 dark:border-white/10 rounded-t-3xl shadow-inner pt-12">
      <div className="max-w-7xl 2xl:max-w-8xl mx-auto px-6 pb-10">
        <div className="flex flex-col md:flex-row md:items-start gap-10 md:gap-16 2xl:gap-24 max-w-5xl mx-auto">
          {/* Logo and tagline */}
          <div className="w-full md:max-w-xs flex-shrink-0 text-center md:text-left">
            <div className="flex items-center gap-3 mb-3" aria-label="James Young logo and name" tabIndex="-1">
              <img 
                src="/James Young_black.png" 
                alt="James Young" 
                className="h-20 w-auto"
                style={{ filter: 'var(--logo-filter)' }}
              />
            </div>
            <p className="max-w-xs text-gray-500 dark:text-gray-400 font-inter text-base">
              Leading teams at the intersection of AI, design, and technology—advancing healthcare through innovative digital solutions and strategic vision.
            </p>
          </div>
          {/* Links */}
          <NavLinks layoutClass="flex-1 min-w-0 grid grid-cols-2 md:grid-cols-4 gap-8 text-center md:text-left" />
        </div>
      <div className="mt-10 pt-8 pb-3 border-t border-gray-100 dark:border-white/10 flex flex-col sm:flex-row items-center justify-between text-gray-500 dark:text-gray-400 font-inter gap-4">
          <span className="text-sm">&copy; {new Date().getFullYear()} James Young. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;